<template>
  <div class="inquire">
    <div class="contact dark-container">
      <div>
        <h2 class="hug">Interested in<br>working together?</h2>
      </div>
      <form class="form" @submit.prevent="sendInquiry">
        <div class="message">
          Get in touch.
        </div>
        <div class="inputs">
          <div class="input">
            <label>Name</label>
            <input type="text" v-model="name" :class="{ 'error-field': errors.name }">
            <div class="error" v-if="errors.name">{{ errors.name }}</div>
          </div>
          <div class="two">
            <div class="input">
              <label>Email</label>
              <input type="text" v-model="email" :class="{ 'error-field': errors.email }">
              <div class="error" v-if="errors.email">{{ errors.email }}</div>
            </div>
            <div class="input">
              <label>Phone</label>
              <input type="text" v-model="phone" :class="{ 'error-field': errors.phone }">
              <div class="error" v-if="errors.phone">{{ errors.phone }}</div>
            </div>
          </div>
          <div class="textarea">
            <label>Message</label>
            <textarea
              placeholder="Inquire..."
              v-model="message"
              :class="{ 'error-field': errors.message }"
            >
            </textarea>
            <div class="error" v-if="errors.message">{{ errors.message }}</div>
          </div>
          <button :class="{'sent': sent}">
            <span v-if="!sent && !sending">
              Submit
            </span>
            <span v-else-if="!sent && sending">
              Sending...
            </span>
            <span v-else>
              Sent
            </span>
            <span v-if="sending" class="sending"></span>
          </button>
        </div>
      </form>
      <div class="location">
        <div>Redwood City, CA</div>
        <div>650.279.9317</div>
        <div>ben@mcmillsconstruction.com</div>
      </div>
    </div>
  </div>
</template>

<script>
import autosize from 'autosize';
import EventBus from '@/event-bus';

export default {
  mounted() {
    autosize(this.$el.querySelectorAll('textarea'));
    EventBus.$emit('carousel:loaded');
  },
  data: () => ({
    errors: {},
    name: null,
    email: null,
    phone: null,
    message: null,
    sent: false,
    sending: false,
  }),
  methods: {
    sendInquiry() {
      if (this.validateInput(this.$data)) {
        this.sending = true;
        /* eslint-disable */
        Email.send({
          SecureToken: 'd31b97b0-13c9-4540-91c7-b9d99c5b922a',
          To: 'ben@mcmillsconstruction.com',
          From: this.email,
          Subject: `Message from ${this.name} (${this.phone})`,
          Body: `
          <b>Message Body:</b><br />
          <pre>
            ${this.message}
          </pre>
          <br /><br />
          ${this.name}<br />
          ${this.email}<br />
          ${this.phone}<br />
          `,
        }).then(message => {
          console.log(message);
          this.sent = true;
          this.sending = false;
        });
        /* eslint-enable */
      }
    },
    validateInput({
      name, email, phone, message,
    }) {
      this.errors = {};

      if (!name) {
        this.errors.name = 'Please enter a name';
      }
      if (!email || !/\S+@\S+\.\S+/.test(email)) {
        this.errors.email = 'Please enter a valid email address';
      }
      if (!phone) {
        this.errors.phone = 'Please enter a phone number';
      }
      if (!message) {
        this.errors.message = 'Please write a message';
      }

      return Object.keys(this.errors).length === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/views/_generics.scss';

.error {
  color: red;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-top: -2px;
  @include fluid-type(8px, 15px);
}

.contact {
  margin-top: -2.35rem;
  padding-top: 7rem;
  font-weight: bold;

  h2 {
    margin-bottom: 2rem;

    @media only screen and (min-width: $tablet-size) {
      width: 33.333%;
    }
  }

  @media only screen and (max-width: $tablet-size) {
    margin-top: 4rem;
    padding-top: 1px;
    display: block;

    margin: $container-padding / 4;
    padding: $container-padding / 4;

    textarea {
      width: 100%;
    }
  }
}

.dark-container {
  @media only screen and (max-width: $mobile-size) {
    padding-top: 2rem;
    padding-bottom: 3rem;
  }
}

.form {
  display: grid;
  // grid-template-columns: 1fr 4fr;
  grid-template-columns: 3fr 7fr;

  label {
    text-transform: uppercase;
    display: block;
    letter-spacing: 2px;
    margin-bottom: 1.2rem;
  }

  input, textarea {
    display: block;
    background: none;
    width: 100%;
    margin-right: 1rem;
    border-radius: 0;
    outline: none;
    border: none;
    padding: 0.75rem 0;
    border-bottom: 2px solid $brand-color-dark;
    margin-bottom: 1rem;
    font-weight: bold;
    color: $brand-color-blue;

    &.error-field {
      border-color: red;
    }
  }

  button {
    border: 2px solid $brand-color-blue;
    padding: 1.5rem 6rem;
    text-transform: uppercase;
    color: $brand-color-blue;
    font-weight: bold;
    background: none;
    outline: none;
    margin-top: 1rem;

    transition: all 0.3s ease;

    &:active {
      background-color: #fff;
    }

    &.sent {
      background: $brand-color-blue;
      color: #fff;

      &:active {
        background-color: darken($brand-color-blue, 15%);
      }
    }
  }

  .location {
    margin-top: 5rem;
  }

  @media only screen and (max-width: $tablet-size) {
    display: block;

    input {
      width: calc(100%);
    }
  }
}

.input, .message {
  margin-top: 2rem;
}

label, input {
  @include fluid-type(12px, 22px);
}

.two {
  display: grid;
  grid-gap: 2rem;
  grid-template-columns: 1fr 1fr;
  @media only screen and (max-width: $tablet-size) {

    display: block;
  }
}

.textarea {
  margin-top: 2rem;
  margin-bottom: 2rem;

  textarea {
    border: 2px solid $brand-color-dark;
    padding: 1rem;
    margin-top: 1rem;
    width: 100%;
    max-height: 350px;
  }
}

.location {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  padding-top: 6rem;

  margin-bottom: 3rem;

  @media only screen and (max-width: $tablet-size) {
    display: block;
    padding-top: 1rem;
    margin-top: 5rem;
    border-top: 1px solid rgba(0, 0, 0, 0.3);
    & > div {
      margin-top: 1rem;
    }
  }
}

@keyframes sendingKeyframes {
  0% {
    transform: translateY(3px) scale(0.92);
    opacity: 0.5;
  }
  50% {
    transform: translateY(0px) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateY(-3px) scale(1.08);
    opacity: 0.2;
  }
}

.sending {
  width: 1rem;
  display: inline-block;
  height: 1rem;
  border-radius: 100%;
  margin-bottom: -2px;
  margin-left: 1rem;
  border: 4px solid $brand-color-blue;

  animation-name: sendingKeyframes;
  animation-duration: 1s;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.455, 0.03, 0.515, 0.955);
}
</style>
